

export default function applyTextMask(
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  fillStyle: string,
  font: string,
  letterSpacing: number,
  maskImg: HTMLImageElement,
  imgX: number,
  imgY: number,
  imgWidth: number,
  imgHeight: number,
) {
  if (!maskImg) return;

  // Create an offscreen canvas
  const offCanvas = document.createElement("canvas");
  const offCtx = offCanvas.getContext("2d", { willReadFrequently: true });

  if (!offCtx) {
    throw new Error("Could not get 2D context");
  }
      
  offCanvas.width = canvas.width;
  offCanvas.height = canvas.height;

  // Draw the text in solid black
  offCtx.fillStyle = fillStyle;
  offCtx.font = font;
  offCtx.letterSpacing = `${letterSpacing}px`;
  offCtx.fillText(text, x, y);

  /*
  const measurement = offCtx.measureText(text);
  offCtx.strokeStyle = 'red';
  offCtx.strokeRect(x - measurement.actualBoundingBoxLeft, y - measurement.actualBoundingBoxAscent, measurement.actualBoundingBoxRight + measurement.actualBoundingBoxLeft, measurement.actualBoundingBoxDescent + measurement.actualBoundingBoxAscent)
  */

  // Get pixel data of the text
  const textData = offCtx.getImageData(0, 0, offCanvas.width, offCanvas.height);
  const textPixels = textData.data;

  // Draw the mask image
  offCtx.drawImage(maskImg, imgX, imgY, imgWidth, imgHeight);

  // Get pixel data of the mask
  const maskData = offCtx.getImageData(0, 0, offCanvas.width, offCanvas.height);
  const maskPixels = maskData.data;

  // Modify text transparency based on the grayscale mask
  for (let i = 0; i < textPixels.length; i += 4) {
    const grayscale = maskPixels[i]; // Red channel (same as green and blue in a grayscale image)
    textPixels[i + 3] = Math.min(grayscale, textPixels[i + 3]); // grayscale; // Apply to the alpha channel
  }

  // Put the modified text back onto the canvas
  offCtx.putImageData(textData, 0, 0);

  // Draw the processed text onto the main canvas
  ctx.drawImage(offCanvas, 0, 0);

}